import { ArrowRight, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from '@nimbitlabs/ui';

const CTASection = () => {
  return (
    <section className="relative py-12 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="relative bg-card border border-border rounded-2xl md:rounded-3xl p-6 md:p-12 lg:p-16 overflow-hidden">
          {/* Glow effects */}
          <div className="absolute top-0 left-1/4 w-64 h-64 bg-primary/20 rounded-full blur-3xl" />
          <div className="absolute bottom-0 right-1/4 w-48 h-48 bg-accent/20 rounded-full blur-3xl" />
          
          <div className="relative max-w-3xl mx-auto text-center">

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-space mb-4 md:mb-6 text-foreground">
              Ready to Dive In?
            </h2>
            
            <p className="text-base md:text-lg text-muted-foreground mb-6 md:mb-10 max-w-2xl mx-auto">
              Start your journey today with our free tier—no credit card required.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Button variant="default" size="xl" asChild>
                <Link to="/signup">
                  Start Today
                  <ArrowRight className="w-5 h-5 ml-1" />
                </Link>
              </Button>
            </div>

            <p className="mt-6 md:mt-8 text-xs md:text-sm text-muted-foreground">
              ✓ No credit card required &nbsp;•&nbsp; ✓ Free version &nbsp;•&nbsp; ✓ Cancel anytime
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
